/* eslint-disable @atlassian/tangerine/import/entry-points */
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
/* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */

import React, { memo } from 'react';
import Text from '@atlaskit/ds-explorations/text';
import { Box, xcss } from '@atlaskit/primitives';
const baseStyles = xcss({
  display: 'inline-flex',
  borderRadius: 'border.radius',
  position: 'static',
  overflow: 'hidden'
});
/**
 * __Lozenge__
 *
 * A lozenge is a visual indicator used to highlight an item's status for quick recognition.
 *
 * - [Examples](https://atlassian.design/components/lozenge/examples)
 * - [Code](https://atlassian.design/components/lozenge/code)
 * - [Usage](https://atlassian.design/components/lozenge/usage)
 */
const Lozenge = /*#__PURE__*/memo(({
  children,
  testId,
  isBold = false,
  appearance = 'default',
  maxWidth = 200,
  style
}) => {
  const appearanceStyle = isBold ? 'bold' : 'subtle';
  const appearanceType = appearance in backgroundColors[appearanceStyle] ? appearance : 'default';
  const maxWidthValue = typeof maxWidth === 'string' ? maxWidth : `${maxWidth}px`;
  const maxWidthIsPc = typeof maxWidth === 'string' && /%$/.test(maxWidth);
  return /*#__PURE__*/React.createElement(Box, {
    as: "span",
    backgroundColor: backgroundColors[appearanceStyle][appearanceType],
    style: {
      backgroundColor: style === null || style === void 0 ? void 0 : style.backgroundColor,
      maxWidth: maxWidthIsPc ? maxWidth : '100%'
    },
    paddingInline: "space.050",
    xcss: baseStyles,
    testId: testId
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: "size.050",
    fontWeight: "bold",
    lineHeight: "lineHeight.100",
    textTransform: "uppercase",
    color: textColors[appearanceStyle][appearanceType],
    shouldTruncate: true,
    UNSAFE_style: {
      color: style === null || style === void 0 ? void 0 : style.color,
      // to negate paddingInline specified on Box above
      maxWidth: maxWidthIsPc ? '100%' : `calc(${maxWidthValue} - ${"var(--ds-space-100, 8px)"})`
    },
    testId: testId && `${testId}--text`
  }, children));
});
Lozenge.displayName = 'Lozenge';
export default Lozenge;

// Lozenge colors
const backgroundColors = {
  bold: {
    default: 'color.background.neutral.bold',
    inprogress: 'color.background.information.bold',
    moved: 'color.background.warning.bold',
    new: 'color.background.discovery.bold',
    removed: 'color.background.danger.bold',
    success: 'color.background.success.bold'
  },
  subtle: {
    default: 'color.background.neutral',
    inprogress: 'color.background.information',
    moved: 'color.background.warning',
    new: 'color.background.discovery',
    removed: 'color.background.danger',
    success: 'color.background.success'
  }
};
const textColors = {
  bold: {
    default: 'inverse',
    inprogress: 'inverse',
    moved: 'warning.inverse',
    new: 'inverse',
    removed: 'inverse',
    success: 'inverse'
  },
  subtle: {
    default: 'subtle',
    inprogress: 'information',
    moved: 'warning',
    new: 'discovery',
    removed: 'danger',
    success: 'success'
  }
};